import { capitalize } from 'vue';

import formatNumber from '@/utils/NumberFormatter';

export default {
  after: (field, [target]) => `Le champ ${capitalize(field)} doit être après ${target}.`,
  after_or_equal: (field, [target]) => `Le champ ${capitalize(field)} doit être après ou égal à ${target}.`,
  alpha_dash: (field) =>
    `Le champ ${capitalize(field)} ne doit contenir que des caractères alpha-numeriques, des tirets et des traits de soulignement.`,
  alpha_num: (field) => `Le champ ${capitalize(field)} ne doit contenir que des caractères alpha-numeriques.`,
  alpha_spaces: (field) =>
    `Le champ ${capitalize(field)} ne doit contenir que des caractères alpha-numeriques et des espaces.`,
  alpha: (field) => `Le champ ${capitalize(field)} ne doit contenir que des caractères alpha-numeriques.`,
  before: (field, [target]) => `Le champ ${capitalize(field)} doit être avant ${target}.`,
  before_or_equal: (field, [target]) => `Le champ ${capitalize(field)} doit être avant ou égal à ${target}.`,
  between: (field, [min, max]) => `Le champ ${capitalize(field)} doit être entre ${min} et ${max}.`,
  boolean: (field) => `Le champ ${capitalize(field)} doit être vrai ou faux. `,
  confirmed: (field) => `La confirmation de ${capitalize(field)} ne correspond pas.`,
  credit_card: (field) => `Le champ ${capitalize(field)} est invalide.`,
  date_between: (field, [min, max]) => `Le champ ${capitalize(field)} doit être entre ${min} et ${max}.`,
  date_format: (field, [format]) => `Le champ ${capitalize(field)} doit avoir le format suivant: ${format}.`,
  date_time: (field) => `The ${capitalize(field)} doit être une date.`,
  decimal: (field, [decimals] = ['*']) =>
    `Le champ ${capitalize(field)} doit être un nombre et peut contenir ${decimals === '*' ? '' : decimals} chiffres après la virgule.`,
  digits: (field, [length]) => `Le champ ${capitalize(field)} doit être un nombre avec exactement ${length} chiffres.`,
  dimensions: (field, [width, height]) =>
    `Le champ ${capitalize(field)} doit avoir une larguer de ${width} Pixels et une hauteur de ${height} Pixels.`,
  domain: (field) =>
    `Le champ ${capitalize(field)} doit être un domaine valide, voici des exemples: apple.com, coca-cola.com, google.com`,
  email: (field) => `Le champ ${capitalize(field)} doit être une adresse courriel valide.`,
  ext: (field) => `Le champ ${capitalize(field)} doit être un fichier valide.`,
  greater_than: (field, min) => `Le champ ${capitalize(field)} doit être plus grand que ${formatNumber(min, '0,0')}.`,
  image: (field) => `Le champ ${capitalize(field)} doit être une image.`,
  in: (field) => `Le champ ${capitalize(field)} doit être valide.`,
  ip: (field) => `Le champ ${capitalize(field)} doit être une adresse IP.`,
  less_than: (field, max) => `Le champ ${capitalize(field)} doit être plus petit que ${formatNumber(max, '0,0')}.`,
  max: (field, [length]) => `Le champ ${capitalize(field)} ne doit pas être plus long que ${length} caractères.`,
  max_value: (field, max) => `Le champ ${capitalize(field)} doit être ${formatNumber(max, '0,0')} ou moins.`,
  mimes: (field) => `Le champ ${capitalize(field)} doit avoir un type de fichier valide.`,
  min: (field, [length]) => `Le champ ${capitalize(field)} doit avoir au moins ${length} caractères de long.`,
  min_value: (field, min) => `Le champ ${capitalize(field)} doit être ${formatNumber(min, '0,0')} ou plus.`,
  not_empty: (field) => `${capitalize(field)} ne peut pas être vide.`,
  not_empty_or_whitespace: (field) => `${capitalize(field)} ne peut pas être vide.`,
  not_in: (field) => `Le champ ${capitalize(field)} doit être valide.`,
  not_in_use: (field) => `Le valeur du champ ${capitalize(field)} est déjà en utilisation.`,
  numeric: (field) => `Le champ ${capitalize(field)} doit contenir uniquement des caractères numériques.`,
  regex: (field) => `Le champ ${capitalize(field)} a un format non valide.`,
  required: (field) => `Le champ ${capitalize(field)} est obligatoire.`,
  requiredPlural: (field) => `Les ${capitalize(field)} sont obligatoires.`,
  size: (field, [size]) => `Le champ ${capitalize(field)} doit avoir une taille inférieure à ${size} KB.`,
  url: (field) => `Le champ ${capitalize(field)} n'est pas une URL valide.`,
  url_with_macros: (field) => `Le champ ${capitalize(field)} n'est pas une URL valide.`,
  uuid: (field) => `${field} n'est pas une UUID valide UUID`,
  string_equals: () => 'Les valeurs ne sont pas égales',
  password: () => 'Le mot de passe est trop faible',
};
